export default {
  namespaced: true,
  state: {
    nbTotal: 0,
    pageEnCours: [],
    etats: [],
    idsDemandes: [],
    produitsDemandes: [],
  },
  getters: {},
  mutations: {
    SET_PAGE_EN_COURS(state, payload) {
      state.pageEnCours = payload;
    },
    SET_NB_TOTAL(state, payload) {
      state.nbTotal = payload;
    },
    SET_IDS(state, payload) {
      state.idsDemandes = payload;
    },
    SET_ETATS(state, payload) {
      let etats = payload.filter(
        (etat) => etat.libelle.indexOf("corriger") == -1
      );

      state.etats = etats;
    },
    SET_PRODUITS(state, payload) {
      state.produitsDemandes = payload;
    },
  },
  actions: {
    clear({ commit }) {
      commit("SET_PRODUITS", []);
      commit("SET_IDS", []);
      commit("SET_ETATS", []);
      commit("SET_PAGE_EN_COURS", []);
      commit("SET_NB_TOTAL", 0);
    },
    setPageDemandes({ commit }, payload) {
      commit("SET_PAGE_EN_COURS", payload.demandes);
      commit("SET_NB_TOTAL", payload.totalDemandes);
    },
    setIds({ commit }, payload) {
      commit("SET_IDS", payload);
    },
    setProduits({ commit }, payload) {
      commit("SET_PRODUITS", payload);
    },
    setEtats({ commit }, payload) {
      commit("SET_ETATS", payload);
    },
  },
};
